/**
 * Backend-owned values of the customersupport tracking API. They are data, not enums
 * (the tracking table stores free strings).
 *
 * @ticket PS-6586
 */
export const TRACKING_FUNCTION_CONNECT_SIP_ORDER = 'connect_sip_order';

/** Name of the tracking property that carries the event type of a `connect_sip_order` entry. */
export const TRACKING_PROPERTY_ACTION = 'action';

/**
 * `action` values written for `connect_sip_order`: LINK_SENT by useraccount, LINK_OPENED and
 * ORDER_CONFIRMED by bookingmgmt. Any other value (e.g. a manual probe row) is ignored by AMIE.
 *
 * @ticket PS-6586
 */
export const SIP_ORDER_LINK_ACTION = {
  sent: 'LINK_SENT',
  opened: 'LINK_OPENED',
  orderConfirmed: 'ORDER_CONFIRMED',
} as const;

/** `ORDER_CONFIRMED.result` when the account already had a SIP account (a second link was used). */
export const SIP_ORDER_RESULT_ALREADY_EXISTS = 'ALREADY_EXISTS';

export interface TrackingProperty {
  name: string;
  value: string;
}

/**
 * One entry of `GET /customersupport/v1/tracking/{userAccountId}` (verified on test 2026-10-14).
 * `start` is offset-less local time (`2026-10-14T23:27:00.000`); `agent` / `isAgent` exist in the
 * response but AMIE does not use them.
 *
 * @ticket PS-6586
 */
export interface TrackingEntry {
  userAccountId: number;
  start: string;
  function: string;
  properties: TrackingProperty[] | null;
}
